import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const approvalFlowsFields =`
id
flowTitle
flowUniqueId
flowProcess
flowUniqueId
`;



export const GET_ALL_APPROVAL_FLOWS = gql`
query getAllProcessApprovalFlows($filtering: ApprovalFlowFilteringInputObject){
    getAllProcessApprovalFlows(filtering:$filtering){
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowsFields}
    }
  }
}
`
;

export const CREATE_APPROVAL_FLOWS = gql`
mutation createApprovalFlowMutation($flow: ApprovalFlowInputObjects!) {
  createApprovalFlowMutation(flow: $flow) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowsFields}
    }
  }
}
`
;

export const UPDATE_APPROVAL_FLOWS = gql`
mutation updateApprovalFlowMutation($flow: ApprovalFlowInputObjects!) {
  updateApprovalFlowMutation(flow: $flow) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowsFields}
    }
  }
}
`
;
export const DELETE_APPROVAL_FLOWS = gql`
mutation deleteApprovalFlowMutation($flowUniqueId: String!) {
  deleteApprovalFlowMutation(flowUniqueId: $flowUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
;